import { GPUResourceUsageFlags } from '@zephyr3d/device';
import { textureTargetMap } from './constants_webgl.js';
import { WebGLBaseTexture } from './basetexture_webgl.js';

class WebGLTextureVideo extends WebGLBaseTexture {
    _source;
    _callbackId;
    constructor(device, source){
        super(device, '2d');
        this._callbackId = null;
        this._format = null;
        this.loadFromElement(source);
    }
    isTextureVideo() {
        return true;
    }
    get source() {
        return this._source;
    }
    destroy() {
        if (this._source && this._callbackId !== null) {
            this._source.cancelVideoFrameCallback(this._callbackId);
        }
        super.destroy();
    }
    init() {
        this.loadElement(this._source);
    }
    /** @internal */ loadFromElement(el) {
        this._flags = GPUResourceUsageFlags.TF_NO_MIPMAP;
        this.loadElement(el);
    }
    generateMipmaps() {
    // Does nothing
    }
    async readPixels(_x, _y, _w, _h, _faceOrLayer, _mipLevel, _buffer) {
        throw new Error(`Video texture does not support readPixels()`);
    }
    readPixelsToBuffer(_x, _y, _w, _h, _faceOrLayer, _mipLevel, _buffer) {
        throw new Error(`Video texture does not support readPixelsToBuffer()`);
    }
    /** @internal */ updateVideoFrame() {
        if (this.object && this._source.currentTime > 0 && !this._source.requestVideoFrameCallback) {
            this.update();
            return true;
        }
        return false;
    }
    /** @internal */ update() {
        this.allocInternal('rgba8unorm', this._source.videoWidth, this._source.videoHeight, 1, 1);
        if (!this._device.isContextLost()) {
            const target = textureTargetMap[this._target];
            const params = this.getTextureCaps().getTextureFormatInfo(this._format);
            this._device.bindTexture(target, 0, this);
            //this._device.context.bindTexture(target, this._object);
            this._device.context.pixelStorei(this._device.context.UNPACK_ALIGNMENT, 1);
            this._device.context.texImage2D(target, 0, params.glInternalFormat, params.glFormat, params.glType[0], this._source);
        }
    }
    /** @internal */ loadElement(element) {
        if (this._source && this._callbackId !== null) {
            this._source.cancelVideoFrameCallback(this._callbackId);
            this._callbackId = null;
        }
        this._source = element;
        if (this._source?.requestVideoFrameCallback) {
            const that = this;
            that._callbackId = this._source.requestVideoFrameCallback(function cb() {
                if (that._object) {
                    that.update();
                    that._callbackId = that._source.requestVideoFrameCallback(cb);
                }
            });
        }
        this.allocInternal('rgba8unorm', Math.max(this._source.videoWidth, 1), Math.max(this._source.videoHeight, 1), 1, 1);
    }
}

export { WebGLTextureVideo };
//# sourceMappingURL=texturevideo_webgl.js.map
